import Distribution from "./Distribution";

export default class DistributionList {
  constructor(name, initialValue, namespace, byteSizeNameSpace, packageFormatNameSpace, formatNameSpace, sizeNameSpace) { // downloadURLNameSpace, accessURLNameSpace, mediaTypeNameSpace,
    this.namespace=namespace;
    this.name=name;
    // this.downloadURLNameSpace = downloadURLNameSpace;
    // this.accessURLNameSpace = accessURLNameSpace;
    // this.mediaTypeNameSpace = mediaTypeNameSpace;
    this.byteSizeNameSpace = byteSizeNameSpace;
    this.packageFormatNameSpace = packageFormatNameSpace;
    this.formatNameSpace = formatNameSpace;
    this.sizeNameSpace = sizeNameSpace;
    this.distributionsList=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getDistributionsList() {
    return this.distributionsList;
  }

  setDistributionsList(fdistributionsList) {
    this.distributionsList=fdistributionsList;
  }

  removeValueObj(item, index) {
    if (index<0 || index>=this.distributionsList.length) {
      return;
    }
    this.distributionsList.splice(index, 1);
  }

  addValueObj(obj) {
    const distribution = new Distribution(this.name, obj, this.namespace, this.byteSizeNameSpace, this.packageFormatNameSpace, this.formatNameSpace, this.sizeNameSpace);
    this.distributionsList.push(distribution);
  }

  parseInputJSON(inputJSON) {
    // const obj=inputJSON[this.namespace];
    const obj=inputJSON;
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.distributionsList.length; index++) {
      const distributionItem=this.distributionsList[index];
      expandedList.push(distributionItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.distributionsList.length; index++) {
      const distributionItem=this.distributionsList[index];
      condition=condition&&distributionItem.isEmpty();
    }
    return condition;
  }
}
